import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-advance-procedures-techniques',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './advance-procedures-techniques.component.html',
  styleUrl: './advance-procedures-techniques.component.scss'
})
export class AdvanceProceduresTechniquesComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/advance-procedures-techniques",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);


    this.titleService.setTitle('Advanced IVF Procedures & Techniques in Kannur | Ncare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Discover cutting-edge fertility solutions at Ncare IVF Centre in Kannur. Our advanced procedures and techniques enhance IVF success with precision, safety, and expert care.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'IVF Procedures, Advanced IVF Procedures, Advanced IVF Techniques'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Advanced IVF Procedures & Techniques in Kannur | Ncare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Discover cutting-edge fertility solutions at Ncare IVF Centre in Kannur. Our advanced procedures and techniques enhance IVF success with precision, safety, and expert care.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
